var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgSearchInBox = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 94 58",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SearchInBox_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M83.512 34.08h-24.09l9.674 9.713a4.073 4.073 0 0 0 2.885 1.197h20.187c.821 0 1.232-.984.65-1.564l-9.306-9.347Z",
  fill: "#FFACE0",
  stroke: "#fff",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.853 34.08h43.318v17.997c0 .723-.592 1.314-1.318 1.314H36.82c-.726 0-1.318-.59-1.318-1.314V38.42c0-2.4 1.953-4.34 4.352-4.34Z",
  fill: "#FFACE0",
  stroke: "#fff",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.923 34.08h24.304l-9.675 9.713a4.073 4.073 0 0 1-2.885 1.197H28.413c-.821 0-1.232-.984-.65-1.564l8.704-8.74a2.039 2.039 0 0 1 1.456-.602v-.005Z",
  fill: "#FFACE0",
  stroke: "#fff",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.147 34.318v18.993",
  stroke: "#fff",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "m60.317 26.152-2.474-2.468M69.192 26.152l2.48-2.468M64.995 23.641v-3.49",
  stroke: "#FF59C1",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.845 53.14H.717",
  stroke: "#D80073",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.045 36.159c-9.6 2.554-19.493-3.16-22.058-12.736-2.566-9.576 3.168-19.445 12.768-22.004 9.6-2.553 19.493 3.16 22.058 12.736 2.56 9.577-3.168 19.445-12.768 22.004Zm-7.86-29.404c-6.652 1.772-10.62 8.608-8.849 15.242 1.776 6.634 8.63 10.592 15.28 8.826 6.65-1.771 10.619-8.608 8.848-15.242-1.776-6.634-8.63-10.592-15.28-8.826Z",
  fill: "#D80073"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.336 57.312a3.875 3.875 0 0 1-2.938-.389 3.863 3.863 0 0 1-1.414-5.282L20.98 30.967a3.884 3.884 0 0 1 5.296-1.41 3.863 3.863 0 0 1 1.413 5.283L15.694 55.513a3.863 3.863 0 0 1-2.358 1.799Z",
  fill: "#D80073"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.4 32.776c7.744 0 14.022-6.262 14.022-13.987 0-7.724-6.278-13.986-14.022-13.986-7.743 0-14.021 6.262-14.021 13.986 0 7.725 6.277 13.987 14.021 13.987Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.213 16.268c.299 1.117.4 2.24.326 3.33M33.235 8.708a10.23 10.23 0 0 1 9.024 5.213",
  stroke: "#FFACE0",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "SearchInBox_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h94v58H0z"
})))));

export default SvgSearchInBox;